<span class="action-button" [ngClass]="getClasses()" [ngbTooltip]="title" tabindex="0">
  <my-small-loader [loading]="loading"></my-small-loader>
  <my-global-icon *ngIf="icon && !loading" [iconName]="icon"></my-global-icon>

  <span *ngIf="label" class="button-label">{{ label }}</span>

  <ng-content></ng-content>
</span>
